import React, {useEffect, useState} from "react";
import { useForm } from "react-hook-form";
import OWASP from "../../../util/owasp";
import CONFIGURACIONES from "../../../util/constants";
import WaveButton from "../WaveButton.jsx";
import { Http } from "../../../helpers/Http.jsx";

const EvaluacionCuantitativaModal = ({ show, onClose, onSave, showCreate, title, initDataEvaluacionCuantitativa, solicitudId }) => {
    const { handleSubmit: handleSubmitModal, register: registerModal, reset:resetModal, getValues: getValuesModal, setValue : setValueModal, formState: { errors: errorsModal } } = useForm({mode: "onChange"});
    const [formaPagoText, setFormaPagoText] = useState(CONFIGURACIONES.INIT.STRING);

    useEffect(() => {
        resetModal();
        if (initDataEvaluacionCuantitativa !== CONFIGURACIONES.INIT.NULL) {
            setFormaPagoText(initDataEvaluacionCuantitativa.formaPago);
            if (initDataEvaluacionCuantitativa.registradoPreviamente == CONFIGURACIONES.INIT.STRING_N) {
                setValueModal('totalVentas', initDataEvaluacionCuantitativa.totalVentas);
                setValueModal('diasVenta', initDataEvaluacionCuantitativa.totalDiasVentas);
                setValueModal('totalMercaderia', initDataEvaluacionCuantitativa.totalMercaderia);
                setValueModal('totalActivoNoCorriente', initDataEvaluacionCuantitativa.totalActivoNoCorriente);
                setValueModal('totalPasivo', initDataEvaluacionCuantitativa.totalPasivo);
                setValueModal('promedioDiasAtraso', initDataEvaluacionCuantitativa.promedioDiasAtraso);

                let totalDetalleActivos = initDataEvaluacionCuantitativa.totalDetalleActivos;
                if (totalDetalleActivos) {
                    Object.keys(totalDetalleActivos).forEach(key => {
                        setValueModal(`${key}`, totalDetalleActivos[key]);
                    });
                }

                let totalInmuebles = getValuesModal('totalInmuebles');
                if (!totalInmuebles) { setValueModal('totalInmuebles', CONFIGURACIONES.INIT.NUMBER_DECIMAL); }

                let totalMaquinariasEquipos = getValuesModal('totalMaquinariasEquipos');
                if (!totalMaquinariasEquipos) { setValueModal('totalMaquinariasEquipos', CONFIGURACIONES.INIT.NUMBER_DECIMAL); }

                let totalDetalleEndeudamientos = initDataEvaluacionCuantitativa.totalDetalleEndeudamientos;
                if (totalDetalleEndeudamientos) {
                    Object.keys(totalDetalleEndeudamientos).forEach(key => {
                        setValueModal(`${key}`, totalDetalleEndeudamientos[key]);
                    });
                }

                let totalCortoPlazo = getValuesModal('totalCortoPlazo');
                if (!totalCortoPlazo) { setValueModal('totalCortoPlazo', CONFIGURACIONES.INIT.NUMBER_DECIMAL); }

                let totalLargoPlazo = getValuesModal('totalLargoPlazo');
                if (!totalLargoPlazo) { setValueModal('totalLargoPlazo', CONFIGURACIONES.INIT.NUMBER_DECIMAL); }
            } else {
                setValueModal('totalVentas', initDataEvaluacionCuantitativa.totalVentas);
                setValueModal('factor', initDataEvaluacionCuantitativa.factor);
                setValueModal('diasVenta', initDataEvaluacionCuantitativa.totalDiasVentas);
                
                setValueModal('ventaDiariaBajaXFactor', initDataEvaluacionCuantitativa.ventaDiariaBajaXFactor);
                setValueModal('totalMercaderia', initDataEvaluacionCuantitativa.totalMercaderia);
                setValueModal('totalActivoNoCorriente', initDataEvaluacionCuantitativa.totalActivoNoCorriente);
                setValueModal('totalActivoCorriente', initDataEvaluacionCuantitativa.totalActivoCorriente);
                setValueModal('totalPasivo', initDataEvaluacionCuantitativa.totalPasivo);
                setValueModal('promedioDiasAtraso', initDataEvaluacionCuantitativa.promedioDiasAtraso);
                setValueModal('cuotaOptima', initDataEvaluacionCuantitativa.cuotaOptima);
                setValueModal('plazoOptimo', initDataEvaluacionCuantitativa.plazoOptimo);
                setValueModal('montoOptimo', initDataEvaluacionCuantitativa.montoOptimo);
                setValueModal('montoMaximoAprobar', initDataEvaluacionCuantitativa.montoMaximoAprobar);
                
                setValueModal('comentarioNegocio', initDataEvaluacionCuantitativa.comentarioNegocio);
                setValueModal('efectivo', initDataEvaluacionCuantitativa.efectivo);
                setValueModal('cuentasXCobrar', initDataEvaluacionCuantitativa.cuentasXCobrar);
                setValueModal('totalInmuebles', initDataEvaluacionCuantitativa.totalInmuebles);
                setValueModal('totalMaquinariasEquipos', initDataEvaluacionCuantitativa.totalMaquinariasEquipos);

                setValueModal('totalActivo', initDataEvaluacionCuantitativa.totalActivo);
                setValueModal('totalCortoPlazo', initDataEvaluacionCuantitativa.totalCortoPlazo);
                setValueModal('totalLargoPlazo', initDataEvaluacionCuantitativa.totalLargoPlazo);
                setValueModal('totalPatrimonio', initDataEvaluacionCuantitativa.totalPatrimonio);
                setValueModal('totalPasivoPatrimonio', initDataEvaluacionCuantitativa.totalPasivoPatrimonio);
                setValueModal('liquidez', initDataEvaluacionCuantitativa.liquidez);
                setValueModal('pruebaAcida', initDataEvaluacionCuantitativa.pruebaAcida);
                setValueModal('capitalTrabajo', initDataEvaluacionCuantitativa.capitalTrabajo);
                setValueModal('rotacionMercaderia', initDataEvaluacionCuantitativa.rotacionMercaderia);
                setValueModal('ratioEndeudamiento', initDataEvaluacionCuantitativa.ratioEndeudamiento);
                setValueModal('ratioEndeudamientoProyectado', initDataEvaluacionCuantitativa.ratioEndeudamientoProyectado);
            }
        }
    }, [initDataEvaluacionCuantitativa]);

    const fnCalcularVentaDiariaBajaYOptima = () => {
        let totalVentas = getValuesModal('totalVentas');
        let factor = getValuesModal('factor');
        let diasVenta = getValuesModal('diasVenta');
        
        if (!totalVentas || !factor || !diasVenta) { return; }
        
        let data = {
            body: {
                'totalVentas': totalVentas,
                'factor': factor,
                'diasVenta': diasVenta,
                'solicitudId': solicitudId,
            }
        };

        Http().post(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/calcular-evaluacion-cuantitativa`, data).then((rpta) => {
            // setValue('cuota', CONFIGURACIONES.INIT.STRING, { shouldValidate: true });
            // setFechaPrimeraCuota(CONFIGURACIONES.INIT.STRING);
            setValueModal('ventaDiariaBajaXFactor', CONFIGURACIONES.INIT.STRING);
            setValueModal('cuotaOptima', CONFIGURACIONES.INIT.STRING);
            setValueModal('plazoOptimo', CONFIGURACIONES.INIT.STRING);
            setValueModal('montoOptimo', CONFIGURACIONES.INIT.STRING);
            setValueModal('montoMaximoAprobar', CONFIGURACIONES.INIT.STRING);

            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setValueModal('ventaDiariaBajaXFactor', rpta.data.ventaDiariaBaja);
                setValueModal('cuotaOptima', rpta.data.cuotaOptima);
                setValueModal('plazoOptimo', rpta.data.plazoOptimo);
                setValueModal('montoOptimo', rpta.data.montoOptimo);
                setValueModal('montoMaximoAprobar', rpta.data.montoMaximo);
            }
        });

        
        // let ventasBaja = parseFloat(totalVentas/diasVenta) * factor;
        // let ventasOptima = parseFloat(totalVentas) * factor;

        // setValueModal('ventaDiariaBajaXFactor', isNaN(ventasBaja) ? '' : ventasBaja.toFixed(2));
        // setValueModal('cuotaOptima', isNaN(ventasOptima) ? '' : ventasOptima.toFixed(2));
    };

    const fnCalcularBalanceSituacion = () => {
        let efectivo = getValuesModal('efectivo');
        let cuentasXCobrar = getValuesModal('cuentasXCobrar');
        
        let totalVentas = getValuesModal('totalVentas');
        let totalMercaderia = getValuesModal('totalMercaderia');
        let totalInmuebles = getValuesModal('totalInmuebles');
        let totalMaquinariasEquipos = getValuesModal('totalMaquinariasEquipos');
        let totalActivoNoCorriente = getValuesModal('totalActivoNoCorriente');
        let totalCortoPlazo = getValuesModal('totalCortoPlazo');
        let totalLargoPlazo = getValuesModal('totalLargoPlazo');
        let totalPasivo = getValuesModal('totalPasivo');
        let ventaDiariaBajaXFactor = getValuesModal('ventaDiariaBajaXFactor');
        
        if (!ventaDiariaBajaXFactor || !efectivo || !cuentasXCobrar || !OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE.test(efectivo) || !OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE.test(cuentasXCobrar)) { return; }
        
        let data = {
            body: {
                'ventaDiariaBajaXFactor': ventaDiariaBajaXFactor,
                'efectivo': efectivo,
                'cuentasXCobrar': cuentasXCobrar,
                'totalVentas': totalVentas,
                'totalMercaderia': totalMercaderia,
                'totalInmuebles': totalInmuebles,
                'totalMaquinariasEquipos': totalMaquinariasEquipos,
                'totalActivoNoCorriente': totalActivoNoCorriente,
                'totalCortoPlazo': totalCortoPlazo,
                'totalLargoPlazo': totalLargoPlazo,
                'totalPasivo': totalPasivo,
                'solicitudId': solicitudId,
            }
        };

        Http().post(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/calcular-balance-situacion`, data).then((rpta) => {
            setValueModal('totalActivoCorriente', CONFIGURACIONES.INIT.NUMBER_DECIMAL);
            setValueModal('totalActivo', CONFIGURACIONES.INIT.NUMBER_DECIMAL);
            setValueModal('totalPatrimonio', CONFIGURACIONES.INIT.NUMBER_DECIMAL);
            setValueModal('totalPasivoPatrimonio', CONFIGURACIONES.INIT.NUMBER_DECIMAL);

            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setValueModal('totalActivoCorriente', rpta.data.totalActivoCorriente);
                setValueModal('totalActivo', rpta.data.totalActivo);
                setValueModal('totalPatrimonio', rpta.data.totalPatrimonio);
                setValueModal('totalPasivoPatrimonio', rpta.data.totalPasivoPatrimonio);

                setValueModal('liquidez', rpta.data.ratiosFinancieros.liquidez);
                setValueModal('pruebaAcida', rpta.data.ratiosFinancieros.pruebaAcida);
                setValueModal('capitalTrabajo', rpta.data.ratiosFinancieros.capitalTrabajo);
                setValueModal('rotacionMercaderia', rpta.data.ratiosFinancieros.rotacionMercaderia);
                setValueModal('ratioEndeudamiento', rpta.data.ratiosFinancieros.ratioEndeudamiento);
                setValueModal('ratioEndeudamientoProyectado', rpta.data.ratiosFinancieros.ratioEndeudamientoProyectado);
            }
        });
    };
    
    return (
        <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{ background: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-xl modal-xxl modal-dialog-centered" role="document">
                <form className="modal-content" action="" onSubmit={handleSubmitModal(onSave)} autoComplete="off">
                    <div className="modal-header">
                        <h5 className="modal-title"> {title}</h5>
                        <button type="button" className="close" onClick={onClose}>
                            <span>&times;</span>
                        </button>
                    </div>

                    <div className="modal-body">
                        <div className="row">
                            <div className="col-sm-12 col-md-4">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h3 className="h4 text-bold">Análisis Financiero</h3>
                                    </div>

                                    <div className="col-sm-12 col-md-11">
                                        <div className="form-group">
                                            <label htmlFor="totalVentas" className="control-label col-form-label">Ventas <small className="text-muted">(Soles)</small> <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="totalVentas"
                                                id="totalVentas"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("totalVentas", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.totalVentas && errorsModal.totalVentas.message }</small>
                                            <input type="hidden" name="diasVenta" {...registerModal('diasVenta')} />
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-11">
                                        <div className="form-group">
                                            <label htmlFor="factor" className="control-label col-form-label">Factor <span className="text-danger">*</span></label>
                                            <select
                                                {...registerModal("factor", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.GENERAL,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    },
                                                    onChange: (e) => {
                                                        setValueModal('factor', e.target.value);
                                                        fnCalcularVentaDiariaBajaYOptima();
                                                        fnCalcularBalanceSituacion();
                                                    }
                                                })} className="form-control" id="factor"  defaultValue={""}
                                            >
                                                <option value="" disabled={CONFIGURACIONES.INIT.STATUS_TRUE}>Seleccione</option>
                                                {
                                                    CONFIGURACIONES.INIT.LIST.FACTORES_EVAL_CUANTITATIVA.map((el, index) => (
                                                        <option key={index} value={el.id}>{el.nombre}</option>
                                                    ))
                                                }
                                            </select>
                                            <small className="invalid-feedback"> { errorsModal.factor && errorsModal.factor.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-11">
                                        <div className="form-group">
                                            <label htmlFor="ventaDiariaBajaXFactor" className="control-label col-form-label">Venta Diaria Baja x Factor <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="ventaDiariaBajaXFactor"
                                                id="ventaDiariaBajaXFactor"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("ventaDiariaBajaXFactor", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.ventaDiariaBajaXFactor && errorsModal.ventaDiariaBajaXFactor.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-11">
                                        <div className="form-group">
                                            <label htmlFor="cuotaOptima" className="control-label col-form-label">Cuota Óptima / Venta Diaria x Factor <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="cuotaOptima"
                                                id="cuotaOptima"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("cuotaOptima", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.cuotaOptima && errorsModal.cuotaOptima.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="plazoOptimo" className="control-label col-form-label">Plazo Óptimo <small className="text-muted">({formaPagoText})</small> <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="plazoOptimo"
                                                id="plazoOptimo"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("plazoOptimo", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.plazoOptimo && errorsModal.plazoOptimo.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-5">
                                        <div className="form-group">
                                            <label htmlFor="montoOptimo" className="control-label col-form-label">Monto Óptimo <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="montoOptimo"
                                                id="montoOptimo"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("montoOptimo", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.montoOptimo && errorsModal.montoOptimo.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="montoMaximoAprobar" className="control-label col-form-label">Monto Máximo para Aprobar <small className="text-muted">(Soles)</small> <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="montoMaximoAprobar"
                                                id="montoMaximoAprobar"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("montoMaximoAprobar", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.montoMaximoAprobar && errorsModal.montoMaximoAprobar.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-5">
                                        <div className="form-group">
                                            <label htmlFor="promedioDiasAtraso" className="control-label col-form-label">Promedio de Atraso en Días <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="promedioDiasAtraso"
                                                id="promedioDiasAtraso"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("promedioDiasAtraso", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.promedioDiasAtraso && errorsModal.promedioDiasAtraso.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-11">
                                        <div className="form-group">
                                            <label htmlFor="comentarioNegocio" className="control-label col-form-label">Comentario de Negocio <span className="text-danger">*</span></label>
                                            <textarea
                                                className="form-control no-resize"
                                                rows="3"
                                                name="comentarioNegocio"
                                                id="comentarioNegocio"
                                                {...registerModal("comentarioNegocio", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.GENERAL,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.comentarioNegocio && errorsModal.comentarioNegocio.message }</small>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h3 className="h4 text-bold">Balance de Situación</h3>
                                    </div>

                                    <div className="col-sm-11 mt-2">
                                        {/* <hr className="pt-1 bg-success"/> */}
                                        <h3 className="h5 text-muted">Activo Corriente</h3>
                                    </div>

                                    <div className="col-sm-12 col-md-11">
                                        <div className="form-group">
                                            <label htmlFor="efectivo" className="control-label col-form-label">Efectivo <small className="text-muted">(Soles)</small> <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="efectivo"
                                                id="efectivo"
                                                {...registerModal("efectivo", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_NUMBERS_DECIMAL_INCLUDE_ZERO,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    },
                                                    onChange: (e) => {
                                                        setValueModal('efectivo', e.target.value);
                                                        fnCalcularBalanceSituacion();
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.efectivo && errorsModal.efectivo.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-11">
                                        <div className="form-group">
                                            <label htmlFor="cuentasXCobrar" className="control-label col-form-label">Cuentas por Cobrar <small className="text-muted">(Soles)</small> <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="cuentasXCobrar"
                                                id="cuentasXCobrar"
                                                {...registerModal("cuentasXCobrar", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_NUMBERS_DECIMAL_INCLUDE_ZERO,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    },
                                                    onChange: (e) => {
                                                        setValueModal('cuentasXCobrar', e.target.value);
                                                        fnCalcularBalanceSituacion();
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.cuentasXCobrar && errorsModal.cuentasXCobrar.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="totalMercaderia" className="control-label col-form-label">Mercadería <small className="text-muted">(Soles)</small> <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="totalMercaderia"
                                                id="totalMercaderia"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("totalMercaderia", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.totalMercaderia && errorsModal.totalMercaderia.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-5">
                                        <div className="form-group">
                                            <label htmlFor="totalActivoCorriente" className="control-label col-form-label text-info">Total <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="totalActivoCorriente"
                                                id="totalActivoCorriente"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("totalActivoCorriente", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.totalActivoCorriente && errorsModal.totalActivoCorriente.message }</small>
                                        </div>
                                    </div>
                                    
                                    <div className="col-sm-10 mt-2">
                                        {/* <hr className="pt-1 bg-success"/> */}
                                        <h3 className="h5 text-muted">Activo No Corriente</h3>
                                    </div>
                                    
                                    <div className="col-sm-12 col-md-11">
                                        <div className="form-group">
                                            <label htmlFor="totalInmuebles" className="control-label col-form-label">Inmueble <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="totalInmuebles"
                                                id="totalInmuebles"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("totalInmuebles", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.totalInmuebles && errorsModal.totalInmuebles.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-11">
                                        <div className="form-group">
                                            <label htmlFor="totalMaquinariasEquipos" className="control-label col-form-label">Maquinaria y Equipos <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="totalMaquinariasEquipos"
                                                id="totalMaquinariasEquipos"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("totalMaquinariasEquipos", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.totalMaquinariasEquipos && errorsModal.totalMaquinariasEquipos.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="totalActivoNoCorriente" className="control-label col-form-label text-info">Total <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="totalActivoNoCorriente"
                                                id="totalActivoNoCorriente"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("totalActivoNoCorriente", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.totalActivoNoCorriente && errorsModal.totalActivoNoCorriente.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-5">
                                        <div className="form-group">
                                            <label htmlFor="totalActivo" className="control-label col-form-label text-success">Total Activo <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="totalActivo"
                                                id="totalActivo"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("totalActivo", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.totalActivo && errorsModal.totalActivo.message }</small>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="row">
                                    <div className="col-sm-12 mt-2">
                                        <h3 className="h5 text-muted">Pasivo & Patrimonio</h3>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-12 col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="totalCortoPlazo" className="control-label col-form-label">Deuda Corto Plazo <small className="text-muted">(Soles)</small> <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="totalCortoPlazo"
                                                id="totalCortoPlazo"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("totalCortoPlazo", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.totalCortoPlazo && errorsModal.totalCortoPlazo.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="totalLargoPlazo" className="control-label col-form-label">Deuda Largo Plazo <small className="text-muted">(Soles)</small> <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="totalLargoPlazo"
                                                id="totalLargoPlazo"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("totalLargoPlazo", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.totalLargoPlazo && errorsModal.totalLargoPlazo.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="totalPasivo" className="control-label col-form-label text-info">Total <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="totalPasivo"
                                                id="totalPasivo"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("totalPasivo", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.totalPasivo && errorsModal.totalPasivo.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="totalPatrimonio" className="control-label col-form-label">Patrimonio <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="totalPatrimonio"
                                                id="totalPatrimonio"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("totalPatrimonio", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_NUMBERS_INCLUDE_NEGATIVES,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.totalPatrimonio && errorsModal.totalPatrimonio.message }</small>
                                        </div>
                                    </div>

                                     <div className="col-sm-12 col-md-12">
                                        <div className="form-group">
                                            <label htmlFor="totalPasivoPatrimonio" className="control-label col-form-label text-success">Total Pasivo + Patrimonio <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="totalPasivoPatrimonio"
                                                id="totalPasivoPatrimonio"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("totalPasivoPatrimonio", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.totalPasivoPatrimonio && errorsModal.totalPasivoPatrimonio.message }</small>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-3">
                                    <div className="col-sm-12">
                                        <h3 className="h4 text-bold">Ratios Financieros</h3>
                                    </div>

                                    <div className="col-sm-12 col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="liquidez" className="control-label col-form-label">Liquidez <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="liquidez"
                                                id="liquidez"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("liquidez", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.liquidez && errorsModal.liquidez.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="pruebaAcida" className="control-label col-form-label">Prueba Ácida <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="pruebaAcida"
                                                id="pruebaAcida"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("pruebaAcida", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.pruebaAcida && errorsModal.pruebaAcida.message }</small>
                                        </div>
                                    </div>
                                    
                                    <div className="col-sm-12 col-md-12">
                                        <div className="form-group">
                                            <label htmlFor="capitalTrabajo" className="control-label col-form-label">Capital de Trabajo <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="capitalTrabajo"
                                                id="capitalTrabajo"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("capitalTrabajo", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.capitalTrabajo && errorsModal.capitalTrabajo.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="rotacionMercaderia" className="control-label col-form-label">Rotación de Mercadería <small className="text-muted">(Inventarios)</small> <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="rotacionMercaderia"
                                                id="rotacionMercaderia"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("rotacionMercaderia", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_NUMBERS_INCLUDE_NEGATIVES,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.rotacionMercaderia && errorsModal.rotacionMercaderia.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="ratioEndeudamiento" className="control-label col-form-label">Ratio de Endeudamiento <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="ratioEndeudamiento"
                                                id="ratioEndeudamiento"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("ratioEndeudamiento", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_NUMBERS_INCLUDE_NEGATIVES,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.ratioEndeudamiento && errorsModal.ratioEndeudamiento.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-12">
                                        <div className="form-group">
                                            <label htmlFor="ratioEndeudamientoProyectado" className="control-label col-form-label">Ratio de Endeudamiento Proyectado <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="ratioEndeudamientoProyectado"
                                                id="ratioEndeudamientoProyectado"
                                                readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                {...registerModal("ratioEndeudamientoProyectado", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_NUMBERS_INCLUDE_NEGATIVES,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                            />
                                            <small className="invalid-feedback"> { errorsModal.ratioEndeudamientoProyectado && errorsModal.ratioEndeudamientoProyectado.message }</small>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="modal-footer">
                        <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={onClose}>
                            <i className="mdi mdi-arrow-left"></i> Cerrar
                        </WaveButton>
                        {showCreate && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect">
                            <i className="mdi mdi-content-save-settings"></i> Guardar
                        </WaveButton>}
                    </div>
                </form>
            </div>
        </div>
    );
};
export default EvaluacionCuantitativaModal;
